import { style, styleVariants } from "@vanilla-extract/css";
import { primitiveTokens } from "../theme/ThemeTokens.css";

export const chipBase = style({
  padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["4x"]}`,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  borderRadius: primitiveTokens.radii.md,
  fontSize: primitiveTokens.type.xs
});

export const chipVariant = styleVariants({
  success: {
    backgroundColor: primitiveTokens.colors.green[300],
    color: primitiveTokens.colors.green[800]
  },
  warning: {
    backgroundColor: primitiveTokens.colors.yellow[300],
    color: primitiveTokens.colors.yellow[800]
  },
  error: {
    backgroundColor: primitiveTokens.colors.red[300],
    color: primitiveTokens.colors.red[800]
  }
});
